class ChildrenAgeInput {

  constructor(elements, translations) {
    this.elements = elements;
    this.translations = translations;
    this.childAgeRows = [];
    this.childAgeSelectors = [];
    this.childAgeSelectorsContainers = [];
    this.numOfChildrenEventHandler = null;
    this.numOfChildrenEventHandler = () => {
      this.render(this.getNumOfChildren(), this.getChildrenAges());
    };
    this.childAgeChangeEventHandler = () => {
      this.elements.children_age_input.value = this.getChildrenAges().join(',');
    };
    this.init();
    if (this.getNumOfChildren() !== null) {
      const childrenAges = this.elements.children_age_input.value.split(',').map(childAge => parseInt(childAge, 10));
      this.render(this.getNumOfChildren(), childrenAges);
    }
  }

  getNumOfChildren() {
    if (this.elements.num_of_children_selector.options[this.elements.num_of_children_selector.selectedIndex].value === '') return null;
    return parseInt(this.elements.num_of_children_selector.options[this.elements.num_of_children_selector.selectedIndex].value, 10);
  }

  init() {
    this.elements.num_of_children_selector.addEventListener('change', this.numOfChildrenEventHandler);
  }

  render(numOfChildren, childrenAges) {
    const numOfSelectors = this.childAgeSelectors.length;
    if (numOfChildren < numOfSelectors) {
      // delete selectors
      // remove selector containers from DOM
      for (let i=numOfSelectors; i > numOfChildren; i--) {
        this.childAgeSelectorsContainers[i-1].remove();
        this.childAgeSelectors[i-1].removeEventListener('change', this.childAgeChangeEventHandler);
      }
      this.childAgeSelectors = this.childAgeSelectors.slice(0, numOfChildren);
      this.childAgeSelectorsContainers = this.childAgeSelectorsContainers.slice(0, numOfChildren);
      // remove rows from DOM
      const newNumOfRows = numOfChildren;
      for (let i=this.childAgeRows.length; i > newNumOfRows; i--) {
        this.childAgeRows[i-1].remove();
      }
      this.childAgeRows = this.childAgeRows.slice(0,newNumOfRows);
    }
    if (numOfChildren > numOfSelectors) {
      // add selectors
      for (let position=numOfSelectors + 1; position <= numOfChildren; position++) {
        this.renderChildSelector(position);
      }
    }
    // update selector values
    this.childAgeSelectors.forEach((selector, i) => {
      if (childrenAges[i] !== undefined) {
        selector.value = childrenAges[i];
      } else {
        selector.selectedIndex = 0;
      }
    });
  }

  getChildAgeSelectorLabel() {
    return this.translations.AGE_YEARS;
  }

  renderChildSelector(position, childAge=null) {
    const rowIndex = position - 1;
    if (rowIndex >= this.childAgeRows.length) {
      while (rowIndex >= this.childAgeRows.length) {
        let newRowElement = this.createChildAgeRow();
        this.elements.num_of_children_selector_container.append(newRowElement);
        this.childAgeRows.push(newRowElement);
      }
    }
    const childAgeSelectorElement = this.createChildAgeSelector(childAge);
    const childAgeSelectorLabel = this.createChildAgeLabel(this.getChildAgeSelectorLabel());
    childAgeSelectorElement.setAttribute('id','id-contact-child-age-' + position);
    this.childAgeSelectors[position-1] = childAgeSelectorElement;
    const selectorContainerElement = document.createElement('div');
    selectorContainerElement.classList.add('pad');
    selectorContainerElement.classList.add('narrow-col');
    selectorContainerElement.classList.add('child-age-selector');
    selectorContainerElement.append(childAgeSelectorLabel);
    selectorContainerElement.append(childAgeSelectorElement);
    this.childAgeSelectorsContainers.push(selectorContainerElement);
    this.appendChildAgeSelectorToRow(this.childAgeRows[rowIndex], selectorContainerElement);
    childAgeSelectorElement.addEventListener('change', this.childAgeChangeEventHandler);
  }

  getChildrenAges() {
    return this.childAgeSelectors.filter(selector => selector.selectedIndex !== 0)
      .map(selector => parseInt(selector.options[selector.selectedIndex].value, 10));
  }

  createChildAgeSelector(selectedAge=null, label='---') {
    const selector = document.createElement('select');
    let emptyOption = document.createElement('option');
    emptyOption.value = '';
    emptyOption.text = label;
    emptyOption.disabled = true;
    emptyOption.selected = true;
    selector.add(emptyOption);
    for (let i=0; i < 16; i++) {
      let option = document.createElement('option');
      option.value = i;
      option.text = i;
      if (selectedAge === i) {
        option.selected = true;
      }
      selector.add(option);
    }
    return selector;
  }

  createChildAgeLabel(label='') {
    const selectorLabel = document.createElement('label');
    selectorLabel.innerHTML = label;
    return selectorLabel;
  }

  createChildAgeRow() {
    const row = document.createElement('div');
    row.classList.add('row');
    row.classList.add('narrow-row');
    row.innerHTML = '<div class="auto-row child-age-selector-wrapper"></div>';
    return row;
  }

  appendChildAgeSelectorToRow(rowElement, childAgeSelectorElement) {
    rowElement.querySelector('.auto-row').append(childAgeSelectorElement);
  }

}

export default ChildrenAgeInput;



// WEBPACK FOOTER //
// ./src/js/forms/ChildrenAgeInput.js